var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioUnmute = function SvgAudioUnmute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "audio_unmute_svg__st0",
    d: "M11.99 16.5c2.41 0 4.36-2.01 4.36-4.5V4.5c0-2.49-1.95-4.5-4.36-4.5S7.63 2.01 7.63 4.5V12c0 2.48 1.91 4.5 4.36 4.5zM18.9 9c-.6 0-1.09.5-1.09 1.08V12c0 3.44-2.82 6.21-6.2 5.99-3-.2-5.44-3.12-5.44-6.23v-1.68C6.17 9.5 5.68 9 5.08 9 4.48 9 4 9.5 4 10.08v1.51c0 4.2 2.91 7.95 6.91 8.52v1.64H9.08c-.83 0-1.49.71-1.45 1.57.03.39.36.68.73.68h7.27c.37 0 .71-.29.73-.68.04-.86-.63-1.57-1.45-1.57h-1.82v-1.58c3.9-.55 6.91-4 6.91-8.17v-1.92C19.99 9.5 19.5 9 18.9 9z"
  })));
};
export default SvgAudioUnmute;